import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { FileImportDto } from "../pages/members/collection/services/collection.service";

@Injectable({
    providedIn: "root",
})
export class GcsService {
    constructor(private _http: HttpClient) { }

    upload(
        body: FileImportDto
    ): Observable<{ fileUrl: string }> {
        return this._http.post<{ fileUrl: string }>(
            `${environment.url}/management/product/v2/images`,
            body
        );
    }
}